import React, { useContext } from "react";
import { BaseEdge, EdgeLabelRenderer, getBezierPath } from "@xyflow/react";
import { IoMdCloseCircle } from "react-icons/io";
import { onEdgeClick } from "../../utils/flowSlice";
import { useDispatch } from "react-redux";
import { DarkModeContext } from "../../context/DarkModeContext";

const CustomEdge = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  markerEnd,
}) => {
  const { darkMode } = useContext(DarkModeContext);
  const [edgePath, labelX, labelY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition,
  });
  const dispatch = useDispatch();

  const handleCloseButton = (e) => {
    e.stopPropagation();
    dispatch(
      onEdgeClick({
        id: id,
      })
    );
  };

  return (
    <>
      <BaseEdge
        path={edgePath}
        markerEnd={markerEnd}
        style={{
          fill: "transparent",
          stroke: darkMode ? "#000000" : "#ffffff", // Change color as needed
          strokeWidth: 2,
          strokeDasharray: "5, 5", // Dashed line style
          pointerEvents: "none",
        }}
      />

      {/* Only show delete button when hovered */}
      <EdgeLabelRenderer style={{ zIndex: 50 }}>
        <div
          style={{
            position: "absolute",
            transform: `translate(-50%, -50%) translate(${labelX}px,${labelY}px)`,
            pointerEvents: "all",
            zIndex: 50,
          }}
          className="nodrag nopan"
        >
          <IoMdCloseCircle
            color="red"
            size={40}
            className="hover:scale-150 z-50 hover:cursor-pointer"
            onClick={(e) => handleCloseButton(e)}
          />
        </div>
      </EdgeLabelRenderer>
    </>
  );
};

export default CustomEdge;
